import { useGetStreamConfig } from './useGetStreamConfig';

export function useIsStreamEnabled() {
  const { data: config } = useGetStreamConfig();
  return config.enabled;
}
